<div class="sd-text-editor" [ngStyle]="{ 'min-height': height + 'px' }">
  <ckeditor
    [editor]="editor"
    [formControl]="control"
    [config]="config"
    tagName="div"
    (ready)="onReady($event)" />
</div>
